import 'semantic-ui-css/semantic.min.css';
import 'src/asset/css/admin.custom.css';
import * as React from "react";
import {Button, Form, Header, Segment, Image, Divider} from "semantic-ui-react";
import { AccountApiService } from 'src/core/api/account/AccountApiService';
import { IApiResponseDto } from 'src/core/dto/common/ApiResponseDto';
import { CookieManager } from 'src/core/utility/CookieManager';
import {ILoginRequest} from "../../../core/api/account/request/LoginRequest";

interface IProps {
    componentName?: string;
}

interface IState {
    model: ILoginRequest;
    isLoading: boolean;
}

export class Login extends React.Component<IProps, IState> {

    private readonly accountApiService = new AccountApiService();

    constructor(props: IProps) {
        super(props);

        this.state = {
            model: {} as ILoginRequest,
            isLoading: false
        }
    }

    public componentWillMount = () => {
        CookieManager.clearSession();
    };

    public render() {
        return (
            <div className="admin-area">
                <div id="login" className='login-form wrapper'>
                    <div className="content">

                        <Image src="/asset/image/logo-md.png" size={"small"} centered={true} />

                        <Form size='large' onSubmit={this.submitData} loading={this.state.isLoading}>
                            <Segment stacked={true} color="blue">
                                <Divider horizontal={true}>
                                    <Header as='h2'>
                                        Login
                                    </Header>
                                </Divider>

                                <Form.Input
                                    onChange={this.formListener}
                                    value={this.state.model.emailAddress}
                                    name="emailAddress"
                                    fluid={true}
                                    icon='user'
                                    iconPosition='left'
                                    type="email"
                                    placeholder='Email Address' />
                                <Form.Input
                                    onChange={this.formListener}
                                    value={this.state.model.password}
                                    name="password"
                                    fluid={true}
                                    icon='lock'
                                    iconPosition='left'
                                    placeholder='Password'
                                    type='password' />

                                <Button primary={true} fluid={true} size='large'>
                                    Login
                                </Button>
                            </Segment>
                        </Form>
                    </div>
                </div>
            </div>
        );
    }

    private submitData = (e: any) => {

        this.setState({
            isLoading: true
        });

        this.accountApiService.login(this.state.model)
            .then((response: IApiResponseDto) => {

                window.location.href = "/admin";

            }).catch((response: any) => {

            this.setState({
                isLoading: false
            });

            alert(response);

        });

        e.preventDefault();
    };

    private formListener = (e: any) => {
        const field = e.target.name;
        const value = e.target.value;

        this.setState(prevState => ({
            model:
                {
                    ...prevState.model,
                    [field]: value
                }
        }));
    }
}


// WEBPACK FOOTER //
// ./src/screen/admin/account/Login.tsx